import React, { useState } from 'react';
import './SectionFive.scss';
import { MailOutlined } from '@ant-design/icons';

function SectionFive() {
  const [copiedIdx, setCopiedIdx] = useState<number | null>(null);
  const isKr = localStorage.getItem('i18nextLng') === 'kr';

  const handleCopy = (email: string, idx: number) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx(null), 2000);
    });
  };

  return (
    <div className="section-five">
      <div className="section-five-container">
        <div className="section-five-main">
          <div className="section-five-inner-wrapper section-five-inner-wrapper-1">
            <p className="section-five-text">Partnership.</p>
            <div className="section-five-link-wr" onClick={() => handleCopy('conceptcube.info@gmail.com', 0)}>
              <a className="section-five-link">conceptcube.info@gmail.com</a>
              <div className="mail">
                <MailOutlined />
              </div>
              {copiedIdx === 0 && <span className="copied-toast">{isKr ? '복사되었습니다!' : 'Copied!'}</span>}
            </div>
          </div>
          <div className="section-five-inner-wrapper section-five-inner-wrapper-1">
            <p className="section-five-text">Recruiting.</p>
            <div className="section-five-link-wr" onClick={() => handleCopy('conceptcube.info@gmail.com', 1)}>
              <a className="section-five-link">conceptcube.info@gmail.com</a>
              <div className="mail">
                <MailOutlined />
              </div>
              {copiedIdx === 1 && <span className="copied-toast">{isKr ? '복사되었습니다!' : 'Copied!'}</span>}
            </div>
          </div>
          <div className="section-five-inner-wrapper section-five-inner-wrapper-2">
            <p className="section-five-text">Contacts.</p>
            <a href="/contacts" className="section-five-link">Contact us &gt; </a>
          </div>
          <h4 className="section-five-title">
            Let's <br />
            Make the world <br />
            Together.
          </h4>
        </div>
      </div>
    </div>
  );
}

export default SectionFive;
